export * as Config from "@web/config/next"

const isLocalDev = process.env.NEXT_PUBLIC_IS_LOCAL_DEV === "true"
const stage = process.env.NEXT_PUBLIC_STAGE || "dev"
const region = process.env.AWS_DEFAULT_REGION || process.env.NEXT_PUBLIC_REGION || "us-east-1"
const userPoolId = process.env.NEXT_PUBLIC_USER_POOL_ID
const userPoolWebClientId = process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID
const webDomain = process.env.NEXT_PUBLIC_WEB_DOMAIN // e.g. tombo.ai
const authDomain = process.env.NEXT_PUBLIC_AUTH_DOMAIN
const appSyncUrl = process.env.NEXT_PUBLIC_ATS_APPSYNC_URL
const sequencerUrl = process.env.NEXT_PUBLIC_SEQUENCER_URL
const sequencerClientId = process.env.NEXT_PUBLIC_SEQUENCER_CLIENT_ID
const sequencerMsEnabled = process.env.NEXT_PUBLIC_SEQUENCER_MS_ENABLED === "true"
const apiURL = process.env.NEXT_PUBLIC_API_URL
const jbClientId = process.env.NEXT_PUBLIC_JB_CLIENT_ID
const jbUrl = process.env.NEXT_PUBLIC_JB_URL
const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN // unused
const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT
const extensionId = process.env.NEXT_PUBLIC_EXT_ID
const mixpanelProjectToken = process.env.NEXT_PUBLIC_MPT ?? process.env.MIXPANEL_PROJECT_TOKEN
const emailSignupEnabled = process.env.NEXT_PUBLIC_EMAIL_SIGNUP_ENABLED
const envName = process.env.NEXT_PUBLIC_ENV_NAME || "test"
const leverClientId = process.env.NEXT_PUBLIC_LEVER_CLIENT_ID

// server side
const nextAuthUrl = process.env.NEXTAUTH_URL
const nextAuthSecret = process.env.NEXTAUTH_SECRET
const appSyncApiKey = process.env.APP_SYNC_API_KEY

const isProd = stage === "prod"

export {
  stage,
  isProd,
  isLocalDev,
  apiURL,
  appSyncUrl,
  webDomain,
  authDomain,
  region,
  userPoolId,
  userPoolWebClientId,
  sequencerUrl,
  sequencerClientId,
  sequencerMsEnabled,
  jbClientId,
  jbUrl,
  sentryDsn,
  sentryEnvironment,
  extensionId,
  mixpanelProjectToken,
  emailSignupEnabled,
  envName,
  appSyncApiKey,
  leverClientId,
  nextAuthUrl,
  nextAuthSecret,
}
